<div
  class="flex w-full max-w-[720px] flex-col overflow-hidden rounded-2xl border border-[#e5e7eb] bg-white shadow-xl dark:border-surface-3 dark:bg-surface-1"
  (click)="$event.stopPropagation()"
>
  <div class="relative border-b border-[#e5e7eb] px-6 py-4 dark:border-surface-3">
    <button
      type="button"
      (click)="close()"
      class="absolute right-4 top-4 inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#f2f5f8] text-[#7d7d93] transition hover:bg-[#e8ecf1] dark:bg-surface-3 dark:text-ink-soft dark:hover:bg-surface-3"
      aria-label="Close"
    >
      <app-icon-v2 name="x" size="16"></app-icon-v2>
    </button>

    <h3 class="pr-10 text-left text-[20px] font-bold leading-snug text-[#141437] dark:text-white">
      {{ title }}
    </h3>
  </div>

  <div class="max-h-[min(70vh,480px)] overflow-y-auto px-6 py-5">
    @if (entries.length) {
      @for (entry of entries; track $index) {
        <article class="mb-5 last:mb-0">
          <div class="mb-2 flex flex-wrap items-baseline gap-x-2 gap-y-1">
            <span class="text-[14px] font-semibold text-[#141437] dark:text-white">{{ entry.userName }}</span>
            @if (entry.timestamp) {
              <span class="text-[13px] text-[#7d7d93] dark:text-ink-muted">{{ entry.timestamp }}</span>
            }
          </div>

          <div
            class="rounded-[10px] border border-[#e5e7eb] bg-[#f2f5f8] px-4 py-3 dark:border-surface-3 dark:bg-surface-2"
          >
            <p class="text-[13px] leading-relaxed text-[#38385b] dark:text-ink-soft">
              <span class="font-semibold text-[#141437] dark:text-white">Action:</span>
              {{ entry.action }}
            </p>
            <p class="mt-2 text-[13px] leading-relaxed text-[#38385b] dark:text-ink-soft">
              <span class="font-semibold text-[#141437] dark:text-white">Notes:</span>
              {{ entry.note }}
            </p>
          </div>
        </article>
      }
    } @else {
      <p class="py-8 text-center text-[14px] text-[#7d7d93] dark:text-ink-muted">
        {{ emptyMessage }}
      </p>
    }
  </div>
</div>
